export default "__VITE_ASSET__DlbWDtac__"